import React, { useState } from "react";
import classes from "./ServiceCard.module.css";

import AnimatedCard from "../../UI/AnimatedCard/AnimatedCard";
import Modal from "../../UI/Modal/Modal";
import Button from "../../UI/Button/Button";
import ServiceAppForm from "./ServiceAppForm/ServiceAppForm";

const ServiceCard = (props) => {
  const [isVisible, setIsVisible] = useState(false); //state responsible for opening the modal

  //close the modal
  const cancel = () => {
    setIsVisible(false);
  };

  //open the modal
  const openModal = (event) => {
    setIsVisible(true);
  };
  return (
    <div className={classes.container}>
      {isVisible && (
        <Modal cancel={cancel} title="احجز موعد" circle={2500}>
          <ServiceAppForm Service = {props.Service} />
        </Modal>
      )}
      <div>
        <h1>{props.Service.ServDesc}</h1>
      </div>
      <div className={classes.doctorsSection}>
        {
          <ul>
            {
              // maps the doctors to Buttons in the clinicCard
              props.Service.SubService.map((subService) => {
                return (
                  <li key={subService.SubServId}>{subService.SubServDesc}</li>
                );
              })
            }
          </ul>
        }
      </div>
      <div className={classes.actions}>
        <Button width="150" height="50" onClick={openModal}>
          احجز موعد
        </Button>
      </div>
    </div>
  );
};
export default ServiceCard;
